module.exports = __webpack_public_path__ + "static/media/eggharbor.62fc41aa.png";